export const forevers = [
  { image: "/images/forever/1.jpg" },
  { image: "/images/forever/2.jpg" },
  { image: "/images/forever/3.jpg" },
];
